export default __webpack_public_path__ + "static/media/rnr-sports-table-19.e2bd681b.webp";